import {useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {getCallDetails} from "../api/calls";
import {getAddressFields} from "../util/locationFallback";

const Call = ({phoneNumber, sourceIdentifier1, sourceIdentifier2, created, callUuid, eml, selected, onSelect}) => {
    const currentFields = getAddressFields(eml);
    const {data: detailCalls} = useQuery({
        queryKey: ['get-call-detail-' + callUuid, {callUuid}],
        queryFn: getCallDetails,
        enabled: !currentFields[1] || !currentFields[2],
        refetchInterval: 30000,
    });
    const addressFields = getAddressFields([...(eml || []), ...(detailCalls?.[0]?.eml || [])]);
    const address = addressFields.filter(Boolean).join(', ') || 'No Resolved Location';
    const [copyStatus, setCopyStatus] = useState('');
    const copyCallId = async event => {
        event.stopPropagation();
        try {
            await navigator.clipboard.writeText(callUuid);
            setCopyStatus('Copied');
        } catch {
            setCopyStatus('Unable to copy call ID');
        }
    };
    const date = new Date(created);
    const formattedDate = date.toLocaleDateString('en-GB', {day: 'numeric', month: 'long', year: 'numeric'});
    const available = value => {
        const text = String(value ?? '').trim();
        return text.toLowerCase() === 'no sim or number detected' ? '' : text;
    };
    const source1 = available(sourceIdentifier1);
    const cell = available(phoneNumber);
    const source2 = available(sourceIdentifier2);
    return <div className={`call-summary${selected ? ' is-selected' : ''}`} onClick={onSelect}>
        <button type="button" className="call-select" aria-pressed={selected}>
        <div className="call-overview">
            <div className="call-location-column">
                <span className="call-location">{address}</span>
                <div className="flex flex-col">
                    {(source1 || cell) && <IdentifierLine label={source1 ? undefined : 'Cell'}
                        value={source1 || cell} kind={source1 ? 'identifier' : 'phone'}/>}
                    {source2 && <IdentifierLine value={source2} kind="group"/>}
                </div>
            </div>
            <time className="call-time" dateTime={created}>
                <span>{date.toLocaleTimeString()}</span>
                <span>{formattedDate}</span>
            </time>
        </div>
        </button>
        <div className="call-id">
            <span>{callUuid}</span>
            <button type="button" className="call-copy" aria-label="Copy call ID" title="Copy call ID" onClick={copyCallId}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="8" y="8" width="12" height="12" rx="2"/>
                    <path d="M16 8V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4"/>
                </svg>
            </button>
        </div>
        {copyStatus && <span className="call-copy-status" role="status">{copyStatus}</span>}
    </div>;
};
export default Call;

const identifierIconPaths = {
    identifier: 'M3 5h18v14H3V5ZM7 9h3v3H7V9Zm-1 7c0-3 5-3 5 0m3-7h4m-4 4h4',
    phone: 'M7 3h10v18H7V3Zm0 3h10M7 18h10m-5 1.5h.01',
    group: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.87M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m7-7.87a4 4 0 0 1 0 7.75',
};

const IdentifierLine = ({label, value, kind}) => <div className="flex items-start gap-2 px-1 py-0.5 font-medium">
    <svg className="h-5 w-5 shrink-0 text-slate-500" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={identifierIconPaths[kind]}/>
    </svg>
    <span>{label ? `${label}: ` : ''}{value}</span>
</div>;
